import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';

@Component({
    selector: 'app-airdisk-main',
    templateUrl: './airdisk-main.component.html',
    styleUrls: ['./airdisk-main.component.scss'],
    standalone: false
})
export class AirdiskMainComponent implements OnInit, OnDestroy {
  currentComponent: string;
  isMobile: any;
  subscription = new Subscription();
  dropDownData: any;
  constructor(
    public airdiskService: AirdiskbrakeService,
    private readonly cdr: ChangeDetectorRef,
    private readonly BreakpointObserver: BreakpointObserver
  ) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }

  ngOnInit() {
    this.subscription.add(
      this.airdiskService.currentComponent$.subscribe((x) => {
        if (x != null) {
          this.currentComponent = x;
        } else {
          this.currentComponent = 'visitorInfo';
        }
        this.cdr.detectChanges();
      })
    );
    this.subscription.add(
      this.airdiskService.getbrandOfActuator().subscribe((dropDownData: any) => {
        this.dropDownData = dropDownData;
        this.cdr.detectChanges();
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
